import { Guid } from "guid-typescript";

export class DeviceInfo {

    serialNumber: string;
    nomenclature: string;

    id?: Guid;
}